import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { INotificationDelegate } from '../../../../../global/helpers/notification_delegate';

class PlanFeedbackGoBackPopup {
  private open: boolean = false;

  constructor(private $state: any) {}

  openedChanged(event: any) {
    const popupOpened = event.detail.value;
    if (popupOpened) {
      return;
    }
    this.open = false;
  }

  goBack() {
    this.open = false;
  }
  goToExplore() {
    this.open = false;
    this.$state.go('my.feed');
  }
}

angular.module('capability-ng-academic-planner').component('planFeedbackGoBackPopup', {
  templateUrl:
    'capability-ng-academic-planner/src/suggestions/components/plan_feedback/components/plan_feedback_go_back_popup/plan_feedback_go_back_popup.html',
  controller: PlanFeedbackGoBackPopup,
  bindings: {
    open: '='
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/components/plan_feedback_go_back_popup/plan_feedback_go_back_popup.ts